<template>
  <div id="index" v-cloak v-visibility-change="change">
    <div v-if="!is_loading">
      <div class="spinner-box">
        <img src="@/assets/img/loadding_pc.gif" alt="">
        <div>努力加载中...</div>
      </div>
    </div>
    <div v-show="is_loading">
      <!-- 头部 -->
      <HeaderTop :headIndex="4" ref="header" @is_judge="is_judge"></HeaderTop>
      <!-- <Hezuo></Hezuo> -->
      <!-- 直播 -->
      <div class="center pc_center main">
        <div class="video_div flex_between">
          <!-- 视频区域 -->
          <div class="video_left video_border video_left_center">
            <div class="video_left_top flex_between">
              <div class="video_title flex_start">
                <!-- <i><img src="https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logo.jpg" alt=""></i> -->
                <div class="title_name flex_between">
                  <div class="title_h5">{{ details.name }}</div>
                  <div class="flex_start title_tag">
                    <span class="flex_start">
                      <i>
                        <img src="@/assets/img/ren.png" alt>
                      </i>
                      麻醉·眼界直播中心
                    </span>
                    <span class="flex_start">
                      <i>
                        <img src="@/assets/img/time.png" alt>
                      </i>
                      开播时间：{{ details.start_time }}
                    </span>
                    <span class="flex_start">
                      <i>
                        <img src="@/assets/img/yanT.png" alt>
                      </i>
                      {{ thousandBitSee }}人/次
                    </span>
                    <span class="flex_start">
                      <i>
                        <img src="@/assets/img/dianzhanP.png" alt>
                      </i>
                      点赞数：{{ thousandBitSeparator }}
                    </span>
                    <div class="label_li flex_center share_button">
                      <i><img src="@/assets/img/fenxiangP.png" alt=""></i>
                      分享
                      <div class="share_div">
                        <!-- <img src="@/assets/img/er.jpg" alt=""> -->
                        <div id="qrcode"></div>
                        <div class="flex_center wx_saosao">微信扫一扫</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="focus flex_center" @click="maskShowc">
                <img src="@/assets/img/focus.png" alt>
                关注
              </div> -->
            </div>

            <div class="video_live flex_center">
              <!-- 欢迎标语 -->
              <div class="welcome">
                欢迎来到直播间
              </div>

              <video id="myVideo" class="video-js vjs-default-skin vjs-big-play-centered" controls="controls"
                preload="auto" :src="record_url" autoplay="auto" data-setup="{}" name="media" webkit-playsinline
                playsinline x5-video-player-type="h5" x5-video-player-fullscreen="true">
                <!-- <source :src="record_url" type="application/x-mpegURL">
                <source :src="record_url" type="video/ogg">
                <source :src="record_url" type="video/mp4">
                <source :src="record_url" type="video/webm">
                <source :src="record_url" type="video/flv">您的浏览器版本偏低，请升级最新版！！！ -->
              </video>
              <div class="roomVideo_bg" v-if="show_tiem == 1 && details.cover"
                :style="{ backgroundImage: 'url(' + details.cover + ')' }">
              </div>
              <div class="roomVideo_bg" v-if="show_tiem == 1 && !details.cover"
                style="backgroundImage:url('http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/051719600a90047693680f30867b8042.jpeg')">
              </div>
            </div>
            <!-- 直播banner -->
            <div class="video_banner flex_center" @click.stop="publicFun">
              <div class="announcement_bg" v-if="!is_time">
                <img src="@/assets/img/announcement_bg.png" alt="">
                <h4 id="msgT" class="msgText count flex_center" v-html="msg"></h4>
              </div>
              <div class="swiper-container videBanner" v-else-if="details.mobile_image">
                <div class="swiper-wrapper">
                  <div class="swiper-slide flex_center" v-for='(liem, index) in details.mobile_image' :key="index">
                    <img :src="IMG_URL + liem" alt="">
                  </div>
                </div>
              </div>
              <div class="announcement_bg" v-else>
                <img src="@/assets/img/announcement_bg.png" alt="">
                <h4 class="msgText flex_center" v-if="show_tiem == 1">直播结束</h4>
                <h4 class="msgText flex_center" v-if="show_tiem == 0">直播中</h4>
              </div>
            </div>
            <div class="video_div video_head flex_between introduce_div">
              <div class="introduce_head flex_start">

                <div class="introduce_li flex_center" @click="head_index = 2" :class="{ 'selected': head_index == 2 }">
                  介绍
                </div>
                <div class="introduce_li flex_center" @click="head_index = 3" :class="{ 'selected': head_index == 3 }">
                  推荐
                </div>
                <div class="introduce_li flex_center" @click="head_index = 1" :class="{ 'selected': head_index == 1 }">
                  <!-- 直播介绍 -->
                  合作
                </div>
                <!-- <div class="introduce_li flex_center" @click="head_index = 4" :class="{'selected' : head_index == 4}">
                  直播总结
                </div> -->
              </div>
              <!-- 礼物 -->
              <div class="introduce_right flex_end ">
                <div class="flex_end introduce_ul">
                  <i class="sliding_div flex_center banner-button_prev" @click="gift_fun(1)">
                    <img src="@/assets/img/left_sliding.png" alt=""></i>
                  <div class="flex_center gift_div swiper-container ">
                    <div class="gift_list swiper-wrapper">
                      <i class="swiper_item swiper-slide" @click="giftAdd('T')"><img src="@/assets/img/tu3.png"
                          alt=""></i>
                      <i class="swiper_item swiper-slide" @click="giftAdd('G')"><img src="@/assets/img/tu12.png"
                          alt=""></i>
                      <!-- <i class="swiper_item swiper-slide" @click="giftAdd('C')"><img src="@/assets/img/tu13.png"
                          alt=""></i> -->
                      <i class="swiper_item swiper-slide" @click="giftAdd('D')"><img src="@/assets/img/tu14.png"
                          alt=""></i>
                      <i class="swiper_item swiper-slide" @click="giftAdd('F')"><img src="@/assets/img/tu11.png"
                          alt=""></i>
                      <i class="swiper_item swiper-slide" @click="giftAdd('E')"><img src="@/assets/img/tu10.png"
                          alt=""></i>
                      <!-- <i class="swiper_item swiper-slide" @click="giftAdd('A')"><img src="@/assets/img/tu2.png"
                          alt=""></i>
                      <i class="swiper_item swiper-slide" @click="giftAdd('B')"><img src="@/assets/img/tu4.png"
                          alt=""></i> -->

                    </div>
                  </div>
                  <i class="sliding_div left_button flex_center banner-button_next" @click="gift_fun(2)"><img
                      src="@/assets/img/left_sliding.png" alt=""></i>
                </div>
                <i class="button_icon" @click="giftAccording">
                  <img src="@/assets/img/gift.png" alt=""></i>
                <i class="button_icon" @click="signFun(1)"><img src="@/assets/img/sign_icon.png" alt=""></i>
              </div>

            </div>
          </div>
          <!-- 讨论区 -->
          <div class="video_right video_border">
            <div class="video_right_head flex_center">
              <div class="head_li flex_center" :class="{ 'selected': video_border_index == 1 }"
                @click.stop="video_border_index = 1">聊天区</div>
              <div class="head_li flex_center" :class="{ 'selected': video_border_index == 2 }"
                @click.stop="video_border_index = 2">精选</div>
            </div>
            <!-- 幸运观众 -->
            <div class="lucky_swiper swiper-container" v-show="viewers.length > 0">
              <div class="swiper-wrapper">
                <div class="swiper-slide flex_center" v-for="liem, index in viewers" :key="index">
                  恭喜 “<i><img :src="liem.image" alt=""></i><span>{{ liem.name }}</span>” 获取幸运观众
                </div>
              </div>
            </div>
            <div class="discuss_ul" id="new_message" v-if="video_border_index == 1">
              <div class="discuss_li" v-for="liem, index in chatArr" :class="{ 'red': liem.member_id == 0 }" :key="index">
                <div class="chat_left">
                  <div class="discuss_li_head flex_between">
                    <div class="discuss_li_name flex_start">
                      <i class="portrait">
                        <img
                          :src="liem.image ? liem.image : 'https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logo.jpg'"
                          alt>
                      </i>
                      <div class="name">{{ liem.name }}</div>
                    </div>
                    <div class="discuss_li_time">{{ liem.time }}</div>
                  </div>
                  <div class="discuss_li_center" v-if="liem.type == '1'" v-html="liem.center">

                  </div>
                  <div class="discuss_li_center li_r_img" v-if="liem.type == '2'">
                    <img :src="liem.center + '?x-oss-process=image/resize,m_lfit,w_289'" alt="">
                  </div>
                </div>
                <!-- <div v-else class="chat_right">
                  <div class="discuss_li_head flex_between">
                    <div class="discuss_li_time">
                      {{liem.time}}
                    </div>
                    <div class="discuss_li_name flex_end">
                      <div class="name">{{liem.name}}</div>
                      <i class="portrait">
                        <img
                          :src="liem.image?liem.image:'https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logo.jpg'"
                          alt>
                      </i>
                    </div>
                  </div>
                  <div class="discuss_li_center" v-html="liem.center"></div>
                </div> -->
              </div>
            </div>
            <div class="discuss_ul select_text li_r_img" v-if="video_border_index == 2">
              <!-- <h4 class="discuss_title">精品留言</h4> -->
              <div class="discuss_center">
                <div class="mess_recomm_li" v-for="(liem, index) in recomm_ul" :key="index">
                  <h6 class="flex_start"><i><img :src="liem.image" alt=""></i>{{ liem.name }}</h6>
                  <div class="mess_recomm_li_cetnter" v-if="liem.type == 1" v-html="liem.center"></div>
                  <div class="mess_recomm_li_cetnter mess_recomm_img" v-if="liem.type == 2">
                    <img :src="liem.center" alt="">
                  </div>
                </div>
              </div>
              <!-- <h4 class="discuss_title heng">提问</h4> -->
              <div class="discuss_center discuss_center_text" v-html="details.live_date"></div>
            </div>
            <!-- 发送消息区 -->
            <div class="Send">
              <!-- 奖品提示 -->
              <!-- <div class="prize_tips flex_center">
                用户<span class="prize_name">张德帥</span>赠送了"<span class="prize_type">火箭</span>"
              </div> -->
              <div class="content">
                <div class="tools-box">
                  <div class="operator-box-btn">
                    <div class="submit">
                      <input class="text" placeholder="请输入...">
                      <div class="submit-btn" @click="out">
                        <input type="button" value="发送">
                      </div>
                    </div>
                    <div class="chat_bottom">
                      <div class="chat_right">
                        <span class="face-icon flex_center" style="margin: 0 10px;">
                          <img src="@/assets/img/smiling.png" alt="">
                        </span>
                        <i class="inp_img_box">
                          <input type="file" style="width: 20px" class="inp_img" @change="handleChange" id="imgInp"
                            ref="inputer" multiple accept="image/*">
                          <img src="@/assets/img/tupian.png" alt id="tupian">
                        </i>
                        <i id="inputBin" @click="goods" @mousedown.stop="giveFun" :class="{ 'giveLike': is_give == true }">
                          <img id="btn" src="@/assets/img/dianzan.png" alt>
                        </i>
                      </div>
                      <!-- <span>点赞数：{{thousandBitSeparator}}</span> -->
                      <!-- <span >{{input_value.length}}/100</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 礼物动态区 -->
            <div class="demoCanvasT demoCanvas">
              <GiftT :gift_arrT="gift_arrT" ref="giftT" @giftFunT="giftFunT">
              </GiftT>
            </div>
            <div class="demoCanvasA demoCanvas">
              <GiftA :gift_arrA="gift_arrA" ref="giftA" @giftFunA="giftFunA">
              </GiftA>
            </div>
            <div class="demoCanvasB demoCanvas">
              <GiftB :gift_arrB="gift_arrB" ref="giftB" @giftFunB="giftFunB">
              </GiftB>
            </div>
            <div class="demoCanvasC demoCanvas">
              <GiftC :gift_arrC="gift_arrC" ref="giftC" @giftFunC="giftFunC">
              </GiftC>
            </div>
            <div class="demoCanvasD demoCanvas">
              <GiftD :gift_arrD="gift_arrD" ref="giftD" @giftFunD="giftFunD">
              </GiftD>
            </div>
            <div class="demoCanvasE demoCanvas">
              <GiftE :gift_arrE="gift_arrE" ref="giftE" @giftFunE="giftFunE">
              </GiftE>
            </div>
            <div class="demoCanvasF demoCanvas">
              <GiftF :gift_arrF="gift_arrF" ref="giftF" @giftFunF="giftFunF">
              </GiftF>
            </div>
            <div class="demoCanvasG demoCanvas">
              <GiftG :gift_arrG="gift_arrG" ref="giftG" @giftFunG="giftFunG">
              </GiftG>
            </div>
            <!-- 用户进入提示 -->
            <div class="user_enter">
              <div class="user_enter_li flex_center" :style="{ color: color_arr[index < 5 ? index : index % 5] }"
                v-for="(liem, index) in user_enterArr" :key="index">
                <i class="user_enter_portrait flex_center" :style="{ backgroundImage: 'url(' + liem.image + ')' }">
                </i>
                {{ liem.text }}
              </div>

              <div class="user_enter_li flex_center gift_li"
                :style="{ backgroundColor: color_arr[index < 5 ? index : index % 5] }" v-for="(liem, index) in gift_user"
                :key="index">
                <i class="user_enter_portrait flex_center" :style="{ backgroundImage: 'url(' + liem.image + ')' }">
                </i>
                <span>{{ liem.text }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="video_div flex_between introduce_div main">
        <!-- 直播介绍 -->
        <div class="video_left video_border introduce">
          <!-- <div class="min_img2" v-if="details.image">
            <img :src="IMG_URL + details.image" alt>
          </div> -->

          <div class="introduce_list" v-if="head_index == 1" v-html="details.cooperation"></div>
          <div class="introduce_list" v-if="head_index == 2" v-html="details.content"></div>

          <div class="introduce_list" v-if="head_index == 4" v-html="details.message ? details.message : zongmessage"></div>
          <!-- <div class="introduce_list" v-if="head_index == 2" v-html="details.live_date">
          </div>-->
          <div class="recommended_list flex_start video_ul" v-if="head_index == 3">
            <div class="recommended_li video_li" v-for="liem, index in recommendArr"
              :style="{ backgroundImage: 'url(' + liem.cover + ')' }" :key="index" @click="linkPage(liem)">
              <div class="video_head flex_between">
                <div class="video_li_title">
                  <div class="title">{{ liem.name }}</div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- 签到 -->
      <SignIn :is_sign="is_sign" :live_id="id" @signFun="signFun"></SignIn>
      <!-- 问答卷 -->
      <AnswerPopup :is_answerPopup="is_answerPopup" :question="question" :options_id="options_id" @answerFun="answerFun"
        @popupFun="popupFun"></AnswerPopup>
      <!-- 尾部 -->
      <Footer></Footer>
    </div>
    <div class="mask" v-if="maskShow">
      <img src="@/assets/img/cuo.png" alt class="mask_icon" @click="maskShowc">
      <div class="er_img">
        <img src="@/assets/img/er.jpg" alt>
        <p>使用微信扫码关注</p>
      </div>
    </div>
  </div>
</template>

<script>
import Hezuo from "@/components/tool/hezuo.vue";
import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
import Footer from "@/components/assembly/Footer.vue"; //尾部模块
import AnswerPopup from "@/components/assembly/AnswerPopup.vue"; //问答卷模块
import SignIn from "@/components/assembly/SignIn.vue"; //签到弹窗
import GiftT from "@/components/assembly/GiftT.vue"; //引用礼物动画
import GiftA from "@/components/assembly/GiftA.vue"; //引用礼物动画
import GiftB from "@/components/assembly/GiftB.vue"; //引用礼物动画
import GiftC from "@/components/assembly/GiftC.vue"; //引用礼物动画
import GiftD from "@/components/assembly/GiftD.vue"; //引用礼物动画
import GiftE from "@/components/assembly/GiftE.vue"; //引用礼物动画
import GiftF from "@/components/assembly/GiftF.vue"; //引用礼物动画
import GiftG from "@/components/assembly/GiftG.vue"; //引用礼物动画
import SVGA from "svgaplayerweb"; //引用svga
import QRCode from "qrcodejs2";

import { AnalyticEmotion, Hashtable } from "@/assets/js/pcsinaFaceAndEffec.js";
import MobileDetect from "@/assets/js/mobile-detect.js";
import "@/assets/node_modules/cos-js-sdk-v5/dist/cos-js-sdk-v5.min.js";
import "@/assets/js/pcmain.js";
import "@/assets/js/main.js";
import "@/assets/js/jquery.js";
import "@/assets/js/establish.js";

import "@/assets/css/main.css";
import "@/assets/css/pcsinaFaceAndEffec.css";
import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/pcmain.css";

var test1, test2, test3, iCount, iCountBubbling;
export default {
  name: "pc_move",
  data() {
    return {
      IMG_URL: this.$IMG_URL,
      LIVE_URL: this.$LIVE_URL, //直播前缀
      IM_URL: this.$IM_URL, //直播前缀
      is_loading: false,

      video_border_index: 1, //聊天室切换index
      head_index: 2,
      user: {}, //用户数据
      bg_img:
        "http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/051719600a90047693680f30867b8042.jpeg",

      chatConter: "", //聊天内容
      chatArr: [], //聊天内容
      page: 1,
      power: 0, //房间类型
      id: "", //直播房间id
      record_url: "", //视频路径
      recomm_ul: [], //精品留言

      // 直播总结
      zongmessage:
        '<div style="text-align: center;width:100%;color:#666">暂无总结</div>',
      groupid: "", //聊天室组
      sign: "", //userSign签名
      details: {}, //详情
      recommendArr: [], //推荐直播
      maskShow: false, //是否显示遮罩
      goodsNum: 0, //点赞数
      position: 0,
      screenWidth: document.body.clientWidth,
      timer: false,
      photo: "", //上传图片
      maxtime: 0,
      show_tiem: null, //倒计时和视频显示切换
      is_time: false, //是否展示倒计时
      msg: "", //倒计时
      d: -1, //天
      h: -1, //小时
      m: -1, //分
      s: -1, //秒
      type: Number,
      open: Number,
      video: "",
      start_time: "",
      time: "",
      video_bott: true,
      input_value: "",
      href: "", //跳转地址

      // seo
      keywords: "",
      is_ie: false, //是否是ie浏览器
      is_give: false, //点赞效果
      websock: null,
      token: null, //socket token
      sever: null, //socket地址
      startTimeNum: 0, //进入直播间时间挫
      startTimeNumS: 0,

      question: {}, //问题答卷
      options_id: null, //答案
      is_answerPopup: false, //是否显示答题弹窗
      is_sign: false, //是否显示签到弹窗

      is_gift: true, //是否点击过礼品
      gift_arrT: [], //奖杯礼物动画
      gift_arrA: [], //点赞
      gift_arrB: [], //热气球
      gift_arrC: [], //表情
      gift_arrD: [], //跑车
      gift_arrE: [], //飞机
      gift_arrF: [], //红气球
      gift_arrG: [], //游艇
      gift_user: [], //送礼物用户
      mySwiper: "", //礼物轮播
      viewers: [], //幸运观众

      user_enterArr: [], //用户信息
      user_att: [], //积累的用户
      color_arr: ["#FFC903", "#FA3131", "#76FF15", "#1FFFCB", "#E539E8"], //用户颜色

      isFun: true, //请求

      is_user_enterArr: true, //是否添加冒泡
    };
  },
  metaInfo() {
    return {
      meta: [{ name: "keywords", content: this.details.seo }],
    };
  },
  components: {
    HeaderTop,
    Footer,
    Hezuo,
    AnswerPopup,
    SignIn,
    GiftT,
    GiftA,
    GiftB,
    GiftC,
    GiftD,
    GiftE,
    GiftF,
    GiftG,
  },
  watch: {},
  computed: {
    thousandBitSeparator: function () {
      if (!this.goodsNum) return 0;
      let num = this.goodsNum;
      num = num.toString().split("."); // 分隔小数点
      var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
      var res = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        if (i % 3 === 0 && i !== 0) {
          res.push(","); // 添加分隔符
        }
        res.push(arr[i]);
      }
      res.reverse(); // 再次倒序成为正确的顺序
      if (num[1]) {
        // 如果有小数的话添加小数部分
        res = res.join("").concat("." + num[1]);
      } else {
        res = res.join("");
      }
      return res;
    },
    thousandBitSee: function () {
      //点赞数
      if (!this.details.see) return 0;
      let num = this.details.see;

      num = num.toString().split("."); // 分隔小数点
      var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
      var res = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        if (i % 3 === 0 && i !== 0) {
          res.push(","); // 添加分隔符
        }
        res.push(arr[i]);
      }
      res.reverse(); // 再次倒序成为正确的顺序
      if (num[1]) {
        // 如果有小数的话添加小数部分
        res = res.join("").concat("." + num[1]);
      } else {
        res = res.join("");
      }
      return res;
    },
  },

  methods: {
    // seo
    getSeo() {
      this.$get("seo").then((res) => {
        if (res.code == 200) {
          this.keywords = res.data[2];
        }
      });
    },
    change(evt, hidden) {
      //浏览器窗口页面切换
      //hidden为false的时候，表示从别的页面切换回当前页面
      //hidden为true的时候，表示从当前页面切换到别的页面
      this.user_enterArr = [];
      if (hidden) {
        this.websock.close();
      } else {
        this.initWebSocket();
      }
    },
    QRcodeFun() {
      //生成二维码
      var qrcode = new QRCode(document.getElementById("qrcode"), {
        text: `${this.$VIEW_URL}/#/min_move?id=${this.id}&url=${this.record_url}&power=${this.power}`,
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.L,
      });
    },
    publicFun() {
      //公共跳转地址
      if (this.href && this.href !== "") {
        location.href = this.href;
      }
    },
    gift_fun(index) {
      //滑动礼物

      if (index == 1) {
        this.mySwiper.slidePrev();
      } else {
        this.mySwiper.slideNext();
      }
    },
    gift_swiperFun() {
      //实例礼物swiper
      this.mySwiper = new Swiper(".gift_div", {
        slidesPerView: 5,
      });
    },
    giftAccording() {
      //显示礼物
      let w = $(".introduce_ul").width();
      let that = this;
      if (w > 0) {
        $(".introduce_ul").animate({ width: "0" });
      } else {
        $(".introduce_ul").animate({ width: "60%" });
      }
    },
    giftAdd(text) {
      if (!this.is_userFun()) {
        return false;
      }
      if (!this.is_gift) {
        layer.open({
          content: "请三秒后再试~",
          time: true,
          skin: "msg",
        });
        return false;
      }
      this.is_gift = false;
      let that = this;
      setTimeout(() => {
        that.is_gift = true;
      }, 3000);

      this.websocketsend(
        JSON.stringify({
          data: {
            mine: {
              name: this.user.name,
              image: this.user.image,
              id: this.user.id,
              mine: true,
              content: text,
            },
            to: {
              id: this.id,
              type: "gift",
            },
            token: this.token,
          },
          type: "gift", //随便定义，用于在服务端区分消息类型
        })
      );
      let arr = that.gift_user;
      arr.push({
        text: "“" + this.user.name + "”赠送了" + this.giftType(text) + "x1",
        image: this.user.image,
        type: 1,
      });
      this.$set(that.gift_user, arr);
      this["gift_arr" + text].push(1);
      this.$refs["gift" + text].downGift();
    },
    giftFunT() {
      //礼物事件
      this.gift_arrT = this.gift_arrT.slice(1);
    },
    giftFunA() {
      this.gift_arrA = this.gift_arrA.slice(1);
    },
    giftFunB() {
      this.gift_arrB = this.gift_arrB.slice(1);
    },
    giftFunC() {
      this.gift_arrC = this.gift_arrC.slice(1);
    },
    giftFunD() {
      this.gift_arrD = this.gift_arrD.slice(1);
    },
    giftFunE() {
      this.gift_arrE = this.gift_arrE.slice(1);
    },
    giftFunF() {
      this.gift_arrF = this.gift_arrF.slice(1);
    },
    giftFunG() {
      this.gift_arrG = this.gift_arrG.slice(1);
    },
    signFun(type) {
      //关闭签到
      if (!this.USER() || this.USER() == {}) {
        layer.open({
          content: "请先登录账号",
          time: true,
          skin: "msg",
        });
        setTimeout(() => {
          this.$refs.header.registered(1);
        }, 1000);
        return false;
      }
      this.is_sign = type == 1 ? true : false;
    },
    popupFun() {
      //答题问答弹窗
      this.is_answerPopup = false;
    },
    answerFun(id) {
      //答题
      this.options_id = id;
    },
    modelsFun() {
      //记录机型
      var device_type = navigator.userAgent; //获取userAgent信息
      var md = new MobileDetect(device_type); //实例化mobile-detect
      var os = md.os(); //获取系统
      var model = "";
      if (os == "iOS") {
        //ios系统的处理
        os = md.os() + md.version("iPhone");
        model = md.mobile();
      } else if (os == "AndroidOS") {
        //Android系统的处理
        os = md.os() + md.version("Android");
      }
      let that = this;
      let end_time = new Date().getTime();
      this.$post("census", {
        url: "pc_move?id=" + this.id,
        type: JSON.stringify(md),
        member_id: this.user.id,
        time: end_time - this.startTimeNum,
        times: this.startTimeNumS,
      }).then((eve) => {
        that.startTimeNum = end_time;
      });
    },
    giveFun() {
      this.is_give = true;
      let that = this;
      setTimeout(() => {
        that.is_give = false;
      }, 100);
    },
    judgeFun(liem) {
      //判断登录
      if (liem.power == 0) {
        return true;
      }
      if (!this.USER() || this.USER() == {}) {
        layer.open({
          content: "请先登录账号",
          time: true,
          skin: "msg",
        });
        setTimeout(() => {
          this.$refs.header.registered(1);
        }, 1000);

        return false;
      }
      if (
        (this.USER().plus < 2 && liem.power == 2) ||
        (this.USER().plus == 0 && liem.power == 1)
      ) {
        layer.open({
          content: this.promptPermissions,
          time: true,
          skin: "msg",
        });
        return false;
      }
      return true;
    },
    //推荐跳转
    linkPage: function (i) {
      if (!this.judgeFun(i)) {
        return false;
      }
      this.$router.replace({
        query: { id: i.id, url: i.live_url, power: i.power },
      });
      // this.$router.go(0)
      window.location.reload();
    },
    getRecommended: function () {
      //获取推荐
      let that = this;
      this.$get("live_recommend", { type: 0 }).then((eve) => {
        that.recommendArr = eve.data;
      });
    },
    joinFun() {
      //新用户入群
      let that = this;
      $.ajax({
        type: "post",
        url: this.IM_URL + "user/joinGroup",
        data: {
          groupid: this.details.chat_id,
          token: that.token,
        },
        success: function (eve) {
          var joinNotify = {
            type: "joinNotify",
            groupid: that.details.chat_id,
            token: that.token,
          };
          that.websocketsend(JSON.stringify(joinNotify));
        },
      });
    },
    addRegister() {
      //加入聊天室
      let that = this;
      $.ajax({
        type: "post",
        url: this.IM_URL + "register",
        data: {
          chat_id: this.details.chat_id,
          nickname: this.user ? this.user.name : "",
          member_id: this.user ? this.user.id : "",
        },
        success: function (ret) {
          //成功的回调函数

          that.getToken();
        },
        error: function (e) { },
      });
    },
    getToken() {
      //获取token
      let that = this;

      $.ajax({
        type: "post",
        url: this.IM_URL + "login",
        data: {
          chat_id: this.details.chat_id,
          nickname: this.user ? this.user.name : "",
          member_id: this.user ? this.user.id : "",
        },
        success: function (ret) {
          //成功的回调函数

          that.token = ret.data.token;
          that.sever = ret.data.sever;
          that.user = ret.data.user;
          that.initWebSocket();
          if (ret.code == 200) {
            setTimeout(() => {
              that.joinFun();
            }, 500);
          }
        },
        error: function (e) {
          that.initWebSocket();
        },
      });
    },
    swiperFun() {
      new Swiper(".videBanner", {
        autoplay: 2000, //可选选项，自动滑动
      });
    },
    is_judge() {
      //判断房间类型
      let that = this;
      console.log(!this.USER(),'result');
      console.log( this.USER().length,'result1');
      if (!this.USER() || this.USER().length == 0) {
        that.$get("username", {}).then((res) => {
          that.user = res.data;
          console.log("=-------------", that.user)
          that.funFun();
        });
      } else {
        that.user = this.USER();
        this.funFun();
      }
    },
    funFun() {
      let that = this;
      if (!this.isFun) {
        return false;
      }
      this.isFun = false;

      //执行方法
      console.log(this.power)
      if (this.power > 0) {
        if (!this.USER() || this.USER() == {}) {
          layer.open({
            content: "请先登录账号",
            time: true,
            skin: "msg",
          });
          setTimeout(() => {
            this.$refs.header.registered(1);
            this.$router.replace("/index");
          }, 1000);
        }
        console.log(this.USER().plus)
        if (
          (this.USER().plus < 2 && this.power == 2) ||
          (this.USER().plus == 0 && this.power == 1)
        ) {
          layer.open({
            content: this.promptPermissions,
            time: true,
            skin: "msg",
          });
          setTimeout(() => {
            this.$router.replace("/index");
          }, 1000);
        }
      }
      that.page = 1;
      that.$nextTick(() => {
        that.getmessage();

        that.getRecommended();
        that.request();
      });
      setTimeout(() => {
        that.isFun = true;
        that.gift_swiperFun();
      }, 500);
    },

    request() {
      //获取直播信息

      let that = this;
      this.$post("live_view", { live_id: this.id }).then((eve) => {
        that.is_loading = true;
        if (eve.data.mobile_image) {
          eve.data.mobile_image = eve.data.mobile_image.split(",");
        }
        that.details = eve.data;
        //
        that.goodsNum = eve.data.goods;
        that.groupid = eve.data.chatroomId;
        that.video = eve.data.record_url;
        that.record_url = eve.data.live_url;
        that.href = eve.data.href;
        that.start_time = eve.data.start_time;
        that.time = eve.data.time;
        that.maxtime = eve.data.date;
        that.open = eve.data.open;
        that.type = eve.data.type;
        that.power = eve.data.power;


        that.addRegister();
        document.title = eve.data.name;
        that.initVideo();

        iCountBubbling = setInterval(function () {
          that.bubblingTime();
        }, 1000);

        iCount = setInterval(function () {
          that.timefc();
          if (
            (that.d == 0 || !that.d) &&
            (that.h == 0 || !that.d) &&
            (that.m == 0 || !that.m) &&
            (that.s == 0 || !that.s)
          ) {
            clearInterval(iCount);
            that.is_time = true;
            setTimeout(() => {
              that.swiperFun();
            }, 5000);
            return false;
          }
        }, 1000);
      });
    },
    bubbling() {
      //冒泡请求
      let that = this;
      if (this.user_att.length > 0) {
        if (that.user_enterArr.length < 60) {
          let arr = that.user_enterArr;
          arr.push({
            text: this.user_att[0].text,
            image:
              this.user_att[0].image.indexOf("logoimg1") > -1
                ? require("../../assets/img/logoimg1.jpg")
                : this.user_att[0].image,
          });
          this.$set(that.user_enterArr, arr);
        } else {
          that.user_enterArr = [
            {
              text: this.user_att[0].text,
              image:
                this.user_att[0].image.indexOf("logoimg1") > -1
                  ? require("../../assets/img/logoimg1.jpg")
                  : this.user_att[0].image,
            },
          ];
        }
        this.user_att.splice(0, 1);
        return false;
      }
      $.ajax({
        type: "get",
        url: this.IM_URL + "person",
        data: {},
        success: function (eve) {
          if (eve.data) {
            let data = eve.data;
            that.user_att = data;
          }
        },
      });
    },
    bubblingTime() {
      //获取当前时间
      var date = new Date();
      var now = date.getTime();
      //设置截止时间
      var str = this.maxtime;
      var endDate = new Date(str);
      var end = endDate.getTime();
      //时间差
      var leftTime = end - now;

      // 直播结束时间

      var jiesuTime = this.start_time + this.time.split("-")[1];
      jiesuTime = jiesuTime.replace(/-/g, "/");
      var end_time = new Date(jiesuTime);
      var endTim = end_time.getTime();
      var rigthTime = now - endTim;
      // 判断直播开始3分钟  结束5分钟请求用户冒泡
      if (leftTime <= 180000 && rigthTime <= 300000) {
        this.bubbling();
      }
    },
    // 倒计时
    timefc: function () {
      //获取当前时间
      var date = new Date();
      var now = date.getTime();
      //设置截止时间
      var str = this.maxtime;
      var endDate = new Date(str);
      var end = endDate.getTime();
      //时间差
      var leftTime = end - now;

      //定义变量 d,h,m,s保存倒计时的时间
      var d, h, m, s;
      if (leftTime >= 0) {
        d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        m = Math.floor((leftTime / 1000 / 60) % 60);
        s = Math.floor((leftTime / 1000) % 60);
      }
      this.d = d;
      this.h = h;
      this.m = m;
      this.s = s;
      this.is_time = true;

      //type  0直播 1录播   open 0开启1关闭
      if (
        this.type == 0 &&
        this.d != undefined &&
        this.h != undefined &&
        this.m != undefined &&
        this.s != undefined
      ) {
        this.video_bott = false;
        this.is_time = false;
        this.msg =
          "距" +
          "直播开始" +
          "还有" +
          "<span>" +
          d +
          "</span>" +
          "天" +
          "<span>" +
          h +
          "</span>" +
          "时" +
          "<span>" +
          m +
          "</span>" +
          "分" +
          "<span>" +
          s +
          "</span>" +
          "秒";
      } else if (
        this.open == 1 &&
        this.type == 0 &&
        this.d == undefined &&
        this.h == undefined &&
        this.m == undefined &&
        this.s == undefined
      ) {
        this.d = 0;
        this.h = 0;
        this.m = 0;
        this.s = 0;
        this.is_time = true;
      } else if (this.open == 0 && this.type == 0) {
        this.d = 0;
        this.h = 0;
        this.m = 0;
        this.s = 0;
        this.is_time = true;
      } else if (this.type == 1) {
        this.d = 0;
        this.h = 0;
        this.m = 0;
        this.s = 0;
      }
    },
    out: function () {
      //发送
      var inputText = $(".text").val();
      if (!inputText) {
        layer.open({
          content: "请输入内容",
          time: true,
          skin: "msg",
        });
        return false;
      }
      let that = this;
      this.$post("forbidden", {
        member_id: this.user.id,
        chat_id: this.details.chat_id,
      }).then((e) => {
        if (e.data == 1) {
          layer.open({
            content: "你已被禁言",
            time: true,
            skin: "msg",
          });
        } else if (e.data == 3) {
          layer.open({
            content: "当前直播未开启留言功能",
            time: true,
            skin: "msg",
          });
        } else {
          $("#info-show ul").append(that.send(AnalyticEmotion(inputText)));
        }
      });
    },
    send: function (content) {
      //发送消息
      //
      if (!this.is_userFun()) {
        return false;
      }
      this.websocketsend(
        JSON.stringify({
          data: {
            mine: {
              name: this.user.name,
              image: this.user.image,
              id: this.user.id,
              mine: true,
              content: content,
            },
            to: {
              id: this.id,
              groupname: this.details.name,
              avatar: this.IMG_URL + this.details.cover,
              name: this.details.name,
              types: 1,
              type: "group",
            },
            token: this.token,
          },
          type: "chatMessage", //随便定义，用于在服务端区分消息类型
        })
      );

      var myDate = new Date();
      let getMonth =
        myDate.getMonth() + 1 >= 10
          ? myDate.getMonth() + 1
          : "0" + (myDate.getMonth() + 1);
      let getDate =
        myDate.getDate() >= 10 ? myDate.getDate() : "0" + myDate.getDate();
      let getHours =
        myDate.getHours() >= 10 ? myDate.getHours() : "0" + myDate.getHours();
      let getMinutes =
        myDate.getMinutes() >= 10
          ? myDate.getMinutes()
          : "0" + myDate.getMinutes();
      let time_num =
        getMonth + "-" + getDate + " " + getHours + ":" + getMinutes;
      this.chatArr.unshift({
        id: 0,
        name: this.user.name,
        image: this.user.image,
        type: 1,
        center: content,
        time: time_num,
      });
      this.input_value = "";
      $(".text").val("");
      this.backTop();
    },
    // 页面回到顶部
    backTop: function () {
      document.getElementById("new_message").scrollTop = 0;
      // let that = this;
      // let timer = setInterval(function () {
      //   let ispeed = Math.floor(-that.scrollTop / 5);
      //   document.documentElement.scrollTop = document.body.scrollTop =
      //     that.scrollTop + ispeed;
      //   if (document.documentElement.scrollTop === 0) {
      //     clearInterval(timer);
      //   }
      // }, 16);
    },
    is_userFun() {
      // if (!this.USER() || this.USER() == {}) {
      if (
        this.details.is_message == 0 &&
        (this.user.mobile == "" || !this.user.mobile)
      ) {
        layer.open({
          content: "请登录账号",
          time: true,
          skin: "msg",
        });
        this.websock.close();
        setTimeout(() => {
          this.$refs.header.registered(1);
        }, 1000);
        return false;
      }
      return true;
    },

    //上传图片
    handleChange: function (e) {
      if (!this.is_userFun()) {
        return false;
      }
      let _this = this;

      let images = "";
      var reader = new FormData();

      reader.append("file", e.target.files[0]);

      //发送图片消息
      $.ajax({
        type: "POST", //提交方式
        url: this.$URL + "upload", //路径
        data: reader,
        processData: false,
        contentType: false,
        success: function (result) {
          //返回数据根据结果进行相应的处理
          //
          _this.websocketsend(
            JSON.stringify({
              data: {
                mine: {
                  name: _this.user.name,
                  image: _this.user.image,
                  id: _this.user.id,
                  mine: true,
                  content: result.data,
                },
                to: {
                  id: _this.id,
                  groupname: _this.details.name,
                  avatar: _this.IMG_URL + _this.details.cover,
                  name: _this.details.name,
                  types: 2,
                  type: "group",
                },
                token: _this.token,
              },
              type: "chatMessage", //随便定义，用于在服务端区分消息类型
            })
          );
          var myDate = new Date();
          let getMonth =
            myDate.getMonth() + 1 >= 10
              ? myDate.getMonth() + 1
              : "0" + (myDate.getMonth() + 1);
          let getDate =
            myDate.getDate() >= 10 ? myDate.getDate() : "0" + myDate.getDate();
          let getHours =
            myDate.getHours() >= 10
              ? myDate.getHours()
              : "0" + myDate.getHours();
          let getMinutes =
            myDate.getMinutes() >= 10
              ? myDate.getMinutes()
              : "0" + myDate.getMinutes();
          let time_num =
            getMonth + "-" + getDate + " " + getHours + ":" + getMinutes;
          _this.chatArr.unshift({
            id: 0,
            name: _this.user.name,
            image: _this.user.image,
            type: 2,
            center: result.data,
            time: time_num,
          });
        },
      });
      this.backTop();
    },
    //获取历史聊天记录
    getmessage: function () {
      let that = this;

      if (this.page == 1) {
        this.chatArr = [];
      }
      this.$post("message", {
        live_id: this.id,
        page: that.page,
        limit: 10,
      }).then((eve) => {
        that.chatArr = that.chatArr.concat(eve.data);
        that.$nextTick(() => {
          that.addImg();
        });
      });
    },
    //监听聊天页面滚动
    handleScroll: function (e) {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight >= scrollHeight - 20) {
        this.page++;
        this.getmessage();
      }
    },
    goods: function () {
      let that = this;
      //点赞
      this.$get("goods", {
        live_id: this.id,
      }).then((eve) => {
        that.goodsNum = eve.data;
      });
    },
    //关注- 遮罩
    maskShowc: function () {
      this.maskShow = !this.maskShow;
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    refresh(type) {
      //刷新数量
      let that = this;
      this.$post("num", { live_id: this.id }).then((e) => {
        that.goodsNum = e.data.data ? e.data.data : that.goodsNum;
        that.details.see = e.data.see ? e.data.see : that.details.see;
        var myPlayer = this.$video("myVideo");
        that.show_tiem = e.data.open;
        if (e.data.open !== 1) {
          if (type == 1) {
            myPlayer.play();
          }
          // that.show_tiem = false;
        } else {
          myPlayer.pause();
          // that.show_tiem = true;
        }
        that.details.live_date = e.data.date
          ? e.data.date
          : that.details.live_date;
      });

      this.$post("mess_recomm", {
        live_id: this.id,
        page: 1,
        limit: 999999,
      }).then((e) => {
        that.recomm_ul = e.data;
      });
    },
    getChat() {
      let that = this;
      this.$post("message", {
        live_id: this.id,
        page: 1,
        limit: this.page * 10,
      }).then((e) => {
        that.chatArr = e.data;
      });
    },
    addImg() {
      $(".li_r_img img").on("click", function () {
        $(this).ImgZoomIn("");
      });
    },
    initVideo() {
      console.log("初始化视频方法")
      //初始化视频方法
      let myPlayer = this.$video(myVideo, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: "muted",
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        "x5-playsinline": "true",
        playsinline: "true",
        "webkit-playsinline": "true",
      });
      myPlayer.src(this.record_url);
      myPlayer.load(this.record_url);
    },
    luckyFun() {
      //幸运观众
      var swiper = new Swiper(".lucky_swiper", {
        direction: "vertical",
        loop: true,
        autoplay: 2000,
      });
    },
    initWebSocket() {
      //初始化weosocket
      const wsuri = this.sever;
      console.log(wsuri + "?token=" + this.token,'------')
      this.websock = new WebSocket(wsuri + "?token=" + this.token);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      let that = this;
      test1 = setInterval(function () {
        that.websocketsend(JSON.stringify({ type: "ping" }));
      }, 1000 * 10);
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);

      let that = this;
      //新用户进入提示
      // if (redata.type == 'joinNotify') {
      //   if (!this.is_user_enterArr) {
      //     return false;
      //   }
      //   that.is_user_enterArr = false;
      //   setTimeout(()=>{
      //     that.is_user_enterArr = true;
      //   },500)
      //   let data = redata.data;//{"system":true,"id":80,"type":"group","content":"湖南省用户15927276570加入了群聊，欢迎下新人吧～"}
      //   if (that.user_enterArr.length < 30) {
      //     let arr = that.user_enterArr;
      //     arr.push({
      //       text: data.content,
      //       image: data.image,
      //     })
      //     this.$set(that.user_enterArr, arr)
      //   } else {
      //     that.user_enterArr = [];
      //   }
      // }
      // 幸运观众
      if (redata.type == "luck") {
        this.viewers.push(redata.data);
        this.luckyFun();
      }
      //送礼品
      if (redata.type == "gift") {
        let data = redata.data;
        this["gift_arr" + data.content].push(1);
        this.$refs["gift" + data.content].downGift();
        if (that.gift_user.length < 30) {
          let arr = that.gift_user;
          arr.push({
            text:
              "“" + data.name + "”赠送了" + this.giftType(data.content) + "x1",
            image: data.image,
            type: 1,
          });
          this.$set(that.gift_user, arr);
        } else {
          that.gift_user = [];
        }
      }
      // 问答卷
      if (redata.type == "question") {
        this.question = redata.data;
        this.question.userId = this.user.id;
        if (this.question.type !== 2) {
          this.options_id = null;
        }
        this.is_answerPopup = true;
      }
      // 聊天
      if (redata.live_id == this.id) {
        this.chatArr = [
          {
            member_id: redata.fromid,
            center: redata.content,
            time: redata.timestamp,
            name: redata.name,
            type: redata.types,
            image: redata.image,
            id: redata.fromid == this.user.id ? 0 : 1,
          },
        ].concat(this.chatArr);
      }
      that.$nextTick(() => {
        that.addImg();
      });
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
      this.$nextTick(() => {
        this.addImg();
      });
    },
    websocketclose(e) {
      //关闭
    },
  },
  created() {
    this.startTimeNum = new Date().getTime(); //获取进入直播时间
    this.startTimeNumS = new Date().getTime();
    this.getSeo();
  },

  mounted() {
    let that = this;
    this.id = this.$route.query.id;
    this.record_url = this.$route.query.url;
    this.power = this.$route.query.power;
    this.QRcodeFun();
    this.is_judge();
    $(".face-icon").SinaEmotion($(".text"));
    $(".face-icon").click(function () {
      $("#emotions").css({ left: "66%", width: "336px", "z-index": "999" });
    });
    document.onkeydown = function (event) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        // enter 键
        //要做的事情
        that.out();
        // alert("按 Enter");
      }
    };
    this.refresh(1);
    that.modelsFun();
    test2 = setInterval(function () {
      that.refresh(0);
      that.modelsFun();
    }, 10000);
    test3 = setInterval(function () {
      that.getChat();
      that.addImg();
    }, 20000);

    window.addEventListener("scroll", this.handleScroll, true);
    if (this._isMobile()) {
      // alert("手机端");
      this.$router.replace({
        path: "min_move",
        query: { id: this.id, url: this.record_url },
      });
    } else {
      // alert("pc端");
      // this.$router.replace({path: 'record',query:{id:this.id,url:this.record_url}});
    }

    //百度统计
    var _hmt = _hmt || [];
    (function () {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?8379155748b2097b694a2dcc7678ee2e";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
    // 进入房间欢迎语动画
    setTimeout(() => {
      $(".welcome").animate({ top: "20px", opacity: "1" }, 1000, function () {
        let data = $(this);
        setTimeout(function () {
          data.animate({ opacity: "0" }, 1000);
        }, 1000);
      });
    }, 1000);
  },
  activated() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.startTimeNum = new Date().getTime(); //获取进入直播时间
    this.startTimeNumS = new Date().getTime();
    this.getSeo();
    let that = this;
    this.id = this.$route.query.id;
    this.record_url = this.$route.query.url;
    this.power = this.$route.query.power;
    this.QRcodeFun();
    this.is_judge();
    $(".face-icon").SinaEmotion($(".text"));
    $(".face-icon").click(function () {
      $("#emotions").css({ left: "66%", width: "336px", "z-index": "999" });
    });
    document.onkeydown = function (event) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        // enter 键
        //要做的事情
        that.out();
        // alert("按 Enter");
      }
    };
    this.refresh(1);
    that.modelsFun();
    test2 = setInterval(function () {
      that.refresh(0);
      that.modelsFun();
    }, 10000);
    test3 = setInterval(function () {
      that.getChat();
      that.addImg();
    }, 20000);

    window.addEventListener("scroll", this.handleScroll, true);
    if (this._isMobile()) {
      // alert("手机端");
      this.$router.replace({
        path: "min_move",
        query: { id: this.id, url: this.record_url },
      });
    } else {
      // alert("pc端");
      // this.$router.replace({path: 'record',query:{id:this.id,url:this.record_url}});
    }

    //百度统计
    var _hmt = _hmt || [];
    (function () {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?8379155748b2097b694a2dcc7678ee2e";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
    // 进入房间欢迎语动画
    setTimeout(() => {
      $(".welcome").animate({ top: "20px", opacity: "1" }, 1000, function () {
        let data = $(this);
        setTimeout(function () {
          data.animate({ opacity: "0" }, 1000);
        }, 1000);
      });
    }, 1000);
  },
  destroyed() {
    // this.modelsFun();
    this.websock.close(); //离开路由之后断开websocket连接
    clearInterval(test2);
    clearInterval(test1);
    clearInterval(test3);
    clearInterval(iCount);
    clearInterval(iCountBubbling);
  },
  beforeDestroy: function () {
    this.websock.close(); //离开路由之后断开websocket连接
    clearInterval(test2);
    clearInterval(test1);
    clearInterval(test3);
    clearInterval(iCount);
    clearInterval(iCountBubbling);
  },
};
</script>
<style>
.discuss_center_text img {
  width: 100%;
}

.vjs-modal-dialog-content,
.video-js .vjs-modal-dialog {
  display: none !important;
}

#msgT.count span {
  color: #ff0000 !important;
}
</style>
<style scoped>
html,
body {
  overflow-x: auto;
}

#index {
  background: #f6f5fa;
  min-width: 1292px;
}

.layui-m-layershade {
  background-color: rgba(0, 0, 0, 0.1);
  pointer-events: auto;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.showtime {
  background-color: #ffffff;
  padding: 0.1rem 0;
}

.mask .mask_icon {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 100px;
  top: 100px;
}

.mask .er_img {
  display: block;
  width: 250px;
  height: 250px;
  top: 30%;
  left: 50%;
  margin-left: -125px;
  position: absolute;
}

html,
body {
  background: #f6f5fa;
  text-align: left;
}

.er_img>img {
  width: 100%;
}

.er_img>p {
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  margin-top: 10px;
}

.pc_center {
  display: block;
  margin-top: 13px !important;
  width: 1292px !important;
  max-width: 1292px !important;
}

.min_center {
  display: none;
}

.main {
  max-width: 1292px;
  min-width: 865px;
  margin: 0 auto;
  width: 1292px;
  overflow: auto;
}

.video_border {
  border-radius: 8px;
  overflow: hidden;
}

/* 视频区*/
.video_div {
  /* padding-top: 8px; */
  align-items: flex-start;
  height: 800px;
}

.video_div .video_left {
  /* width: calc(100% - 347px); */
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.video_div .video_left .video_left_top {
  height: 80px;
  background: #fff;
  padding: 0 20px;
  z-index: 6;
}

.video_left_top .video_title {
  width: calc(100% - 80px);
  align-items: center;
}

.video_left_top .video_title>i {
  width: 53px;
  height: 53px;
  border-radius: 50%;
  overflow: hidden;
  background: #f7f7f7;
  margin-right: 12px;
}

.video_left_top .video_title>.title_name {
  flex-direction: column;
  align-items: flex-start;
  height: 50px;
}

.video_left_top .video_title>.title_name .title_h5 {
  font-size: 20px;
  line-height: 23px;
  color: #000;
  font-weight: bold;
}

.video_left_top .video_title>.title_name .title_tag span {
  margin-right: 34px;
  color: #666666;
  font-size: 13px;
  line-height: 1em;
  align-items: center;
}

.video_left_top .video_title>.title_name .title_tag span>i {
  width: 12px;
  margin-right: 5px;
}

.video_left_top .focus {
  width: 95px;
  height: 33px;
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  background: #f24d5b;
  font-size: 16px;
}

.video_left_top .focus>img {
  width: 16px;
  margin-right: 8px;
}

.video_live {
  width: 100%;
  height: calc(100% - 276px);
  background-color: transparent;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  position: relative;
}

.video_live>video {
  width: 100%;
  height: 100%;
}

.video_live .count {
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  /* display: flex;
                justify-content: center;
                align-content: center; */
  color: red;
  font-weight: bold;
  height: calc(100%);
  background-color: rgba(0, 0, 0, 0.8);
  line-height: 684px;
  text-align: center;
  width: 100%;
  z-index: 99 !important;
}

.video_live>img {
  width: 100%;
}

.video_left_center.video_border.video_left {
  width: calc(100% - 360px);
  margin: 0;
}

/* 直播banner */
.video_banner {
  height: 112px;
  background-color: #b5a3aa;
  cursor: pointer;
}

.video_banner h4 {
  font-size: 30px;
  color: #fff;
}

.video_banner .swiper-container {
  width: 100%;
  height: 100%;
}

/* 直播切换 */
.video_head.video_div.introduce_div {
  height: 85px;
  background: #fff;
  align-items: center;
  padding: 0 26px;
}

/* 导论区 */
.video_div .video_right {
  width: 346px;
  height: 100%;
  background: #fff;
  position: relative;
}

.video_right_head {
  margin-bottom: 10px;
}

.video_right_head>.head_li {
  width: 50%;
  height: 49px;
  background: #dcdcdc;
  color: #fff;
  position: relative;
  font-size: 18px;
  cursor: pointer;
}

.spinner-box {
  width: 100%;
  height: 100vh;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

.video_right_head>.head_li::after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
  float: left;
  width: 0;
  height: 0;
  border-width: 8px;
  border-style: solid;
  border-color: #dcdcdc transparent transparent transparent;
}

.video_right_head>.head_li.selected {
  background: #f24d5b;
}

.video_right_head>.head_li.selected::after {
  border-color: #f24d5b transparent transparent transparent;
}

.video_div .video_right .discuss_ul {
  padding: 20px 15px;
  height: calc(100% - 188px);
  overflow-y: auto;
  /* -ms-overflow-style: none;
                scrollbar-width: none; */
  transition: all 0.25s ease;
}

.video_div .video_right .discuss_ul::-webkit-scrollbar {
  /* display: none; */
  /* Chrome Safari */
}

.video_div .video_right .discuss_ul .discuss_li {
  margin-bottom: 20px;
}

.discuss_ul .discuss_li_head {
  height: 30px;
}

.discuss_li_head .discuss_li_name {
  width: calc(100% - 90px);
  align-items: center;
}

.discuss_li_name>.portrait {
  width: 30px;
  height: 30px;
  background: #f7f7f7;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 8px;
}

.discuss_li_name>.name {
  font-size: 14px;
  color: #3285d9;
  text-align: left;
}

.discuss_li_time {
  font-size: 14px;
  color: #999;
  max-width: 80px;
}

.discuss_li_center {
  text-align: left;
  font-size: 14px;
  color: #1a1a1a;
  margin-top: 8px;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

.discuss_li .chat_right .discuss_li_center {
  text-align: right;
}

.discuss_li .chat_right .portrait {
  margin: 0 0 0 8px;
}

.discuss_li.red .name,
.discuss_li.red .discuss_li_center {
  color: #ff0000 !important;
  font-weight: bold;
}

.inputBox {
  height: 100px;
  border-top: 1px solid #e2e2e2;
  padding: 10px 9px 0 9px;
}

.inputBox .icon_div {
  height: 45px;
}

.inputBox .icon_div .icon_ul>i {
  width: 20px;
  margin: 0 10px;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.inp_img_box {
  position: relative;
}

.inp_img {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
}

.inputBox .icon_div>span {
  font-size: 13px;
  color: #999;
}

.input_div {
  height: 50%;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
}

.input_div>.textarea {
  height: 100%;
  border: 0;
  width: calc(100% - 50px);
  padding: 6px 12px;
  font-size: 12px;
  overflow: hidden;
  overflow-y: auto;
  color: #666;
  resize: none;
}

.input_div .enter_buttom {
  width: 52px;
  font-size: 14px;
  color: #fff;
  height: 100%;
  cursor: pointer;
  background: #f24c5a;
}

/* 直播介绍 */
.introduce_div {
  height: auto;
}

.introduce {
  /* background: #fff; */
}

.introduce .introduce_head {
  height: 60px;
  border-bottom: 1px solid #e2e2e2;
  padding: 0 40px;
  background: #fff;
  align-items: center;
}

.introduce_head .introduce_li {
  font-size: 18px;
  color: #777;
  margin-right: 31px;
  height: 100%;
  cursor: pointer;
  position: relative;
}

.introduce_head .introduce_li.selected {
  color: #000;
  font-weight: bold;
}

.introduce_head .introduce_li.selected::after {
  position: absolute;
  content: "";
  left: 50%;
  width: 100%;
  height: 3px;
  transform: translateX(-50%);
  bottom: 0;
  background: #f24c5a;
  border-radius: 2px;
}

.introduce_list {
  overflow-x: hidden;
  padding: 20px 0;
}

.introduce_list img {
  width: 100%;
}

.introduce_list p img {
  max-width: 100%;
}

/* 直播推荐 */

.recommended_list {
  padding: 10px 9px;
  flex-wrap: wrap;
  width: calc(100% + 24px);
  transform: translateX(-8px);
}

.recommended_list .recommended_li {
  width: calc(33.3% - 16px);
  margin: 8px;
  height: 226px;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 20px rgba(71, 71, 71, 0.11);
  transition: all 0.5s ease;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}

.video_ul .video_li:hover {
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0);
}

.recommended_li .recommended_li_img {
  height: 100%;
  overflow: hidden;
  background: #f1f1f1;
}

.recommended_li .recommended_li_img>img {
  width: 100%;
}

.recommended_li .recommended_text {
  /* width: calc(100% - 112px); */
  padding: 10px 16px;
  text-align: left;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
}

.recommended_text .li_title {
  font-size: 20px;
  font-weight: bold;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #1a1a1a;
  margin-bottom: 10px;
}

.recommended_text .li_time {
  font-size: 13px;
  color: #666;
}

.recommended_text .li_time>i {
  width: 12px;
  margin-right: 3px;
}

.recommended .more {
  height: 48px;
  border-top: 1px solid #e2e2e2;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.recommended .more>i {
  width: 14px;
  margin-left: 6px;
}

#myVideo {
  width: 100%;
  background: #fff;
  height: 100%;
}

.myVideo .myVideo>div {
  width: 100%;
  height: 100%;
}

/* 点赞 */
#inputBin {
  height: 20px;
  width: 20px;
  padding: 0;
  background: 0;
  box-shadow: none;
  position: relative;
  margin: auto 10px;
  border-radius: 50%;
  cursor: pointer;
}

#inputBin>img {
  height: 100%;
  background: transparent !important;
  box-shadow: none !important;
  width: 100%;
  /* margin: 0 !important; */
  margin: auto 0;
}

#inputBin.giveLike {
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
}

.operator-box-btn>span {
  line-height: 20px;
}

#inputBin>i {
  width: 18px;
  height: 18px;
}

#content {
  width: 100%;
}

.min_img2>img {
  width: 100%;
  display: block;
  margin: 0 auto;
}

#roomVideo_html5_api {
  width: 100%;
  height: 100%;
}

.btnc {
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.1);
  position: absolute;
  margin: 0 auto;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnc .diamond {
  text-align: center;
  text-align: center;
  line-height: 100px;
  border-radius: 50%;

  /* background: white; */
}

.layui-m-layer1 .layui-m-layerchild {
  background-color: transparent;
}

.Send {
  height: 100px;
  width: 100%;
}

.submit {
  width: 100%;
  border: 1px solid rgba(226, 226, 226, 1);
  border-radius: 0.4rem;
  display: flex;
  margin: 10px;
}

.tools-box .operator-box-btn {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}

.submit>input {
  flex: 1;
}

.tools-box .submit-btn input {
  width: 100%;
  height: 100%;
  font-family: 微软雅黑;
  font-size: 1.4rem;
  color: #ffffff;
  cursor: pointer;
  border: none;
  outline: none;
  background-color: #f24d5b;
  border-radius: 0 0.4rem 0.4rem 0;
  padding: 10px 0;
  background-image: url();
}

.face-icon {
  float: left;
  margin-top: 0;
  margin-left: 5px;
  margin-right: 5px;
  font-family: 微软雅黑;
  font-size: 0 !important;
  color: #9c6;
  cursor: pointer;
}

.video_ul {
  flex-wrap: wrap;
  /* width: calc(100% + 40px); */
  /* margin-left: 50%; */
  /* transform: translateX(-50%); */
  align-items: flex-start;
  display: flex;
}

.video_ul .video_li {
  background: #fff;
  /* height: 200px; */
  width: calc(33% - 20px);
  margin: 10px;
  height: 223px;
  border-radius: 10px;
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0.11);
  transition: all 0.5s ease;
  cursor: pointer;
  /* min-width: calc(33% - 40px); */
}

.video_ul .video_li:hover {
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0);
}

.video_ul .video_li .video_li_title {
  width: 100%;
  align-items: center;
}

.video_ul .video_li .video_li_title .title {
  max-width: calc(100% - 40px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  margin: 0 auto;
  font-weight: bold;
}

.video_ul .video_li .video_li_title .tag {
  margin-left: 4px;
  width: 33px;
  height: 18px;
  border-radius: 4px;
  background: #ee8a60;
  color: #ffffff;
  font-size: 12px;
}

.video_ul .video_li .video_head {
  position: absolute;
  flex-direction: column;
  align-items: flex-start;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  line-height: 50px;
  height: 50px;
  color: #fff;
  /* border-bottom: 1px dashed #E4E4E4; */
}

.video_ul .video_li .video_head .video_time>.video_time_img {
  width: 22px;
  margin-right: 8px;
}

.video_ul .video_li .video_head .video_time>span {
  font-size: 14px;
  color: #818a92;
}

.video_center {
  align-items: center;
  height: calc(100% - 114px);
  padding: 20px 0;
}

.video_center>.touxiao {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 8px;
}

.video_center .video_name {
  font-size: 14px;
  color: #525963;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
  text-align: left;
}

.video_center .tag_title {
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
}

.video_center .tag_title>span {
  font-size: 14px;
  color: #525963;
  margin-right: 10px;
  white-space: nowrap;
}

.roomVideo_bg {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-repeat: no-repeat;
  background-color: #000;
  background-size: cover;
  background-position: center;
}

.video_bottom_banner {
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
}

.chat_bottom {
  padding: 0 16px 0 0;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.chat_bottom .chat_right {
  display: flex;
  align-items: center;
}

.recommended_list .recommended_li {
  position: relative;
  overflow: hidden;
}

.recommended_list .recommended_li img {
  width: 100%;
}

.recommended_list .recommended_li .recommended_li_img {
  height: 240px;
  overflow: hidden;
  border-radius: 12px;
  width: 100%;
}

.recommended_list .recommended_li .recommended_li_img img {
  border-radius: 12px;
}

.face-icon img {
  width: 20px;
}

.welcome {
  position: absolute;
  top: -20px;
  text-align: center;
  opacity: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 80%;
  min-width: 30%;
  min-height: 30px;
  padding: 10px 20px;
  font-size: 16px;
  color: #333;
  box-shadow: 2px 2px 14px rgba(247, 244, 248, 0.6);
  border-radius: 8px;
  background: #fff;
  z-index: 9999;
}

.user_enter {
  position: absolute;
  bottom: 120px;
  width: 100%;
  right: 0;
}

.user_enter .user_enter_li {
  font-size: 16px;
  color: #333;
  position: absolute;
  bottom: 0;
  opacity: 0;
  right: 0px;
  white-space: nowrap;
  animation: myfirst 4s ease;
}

.user_enter .user_enter_li .user_enter_portrait {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  overflow: hidden;
  display: block;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-right: 10px;
}

@keyframes myfirst {
  0% {
    bottom: 0px;
    opacity: 0;
  }

  20% {
    bottom: 40px;
    opacity: 1;
  }

  100% {
    bottom: 160px;
    opacity: 0;
  }
}

.announcement_bg {
  position: relative;
  width: 100%;
}

.announcement_bg img {
  width: 100%;
}

.announcement_bg .msgText {
  position: absolute;
  top: 50%;
  width: 100%;
  overflow: hidden;
  transform: translate(-50%, -50%);
  left: 50%;
  color: #000;
}

.swiper-slide img {
  width: 100%;
}

.discuss_title {
  font-size: 22px;
  color: #1a1a1a;
  font-weight: bold;
  margin-bottom: 10px;
}

.discuss_title.heng {
  border-top: 0.005rem solid #e2e2e2;
  padding-top: 18px;
}

.discuss_center {
  margin-bottom: 16px;
}

.discuss_center .mess_recomm_li {
  margin: 14px 0;
}

.discuss_center .mess_recomm_li>h6 {
  font-size: 14px;
  color: #3285d9;
}

.discuss_center .mess_recomm_li>h6>i {
  width: 30px;
  border-radius: 50%;
  overflow: hidden;
  height: 30px;
  margin-right: 6px;
}

.discuss_center .mess_recomm_li>.mess_recomm_li_cetnter {
  font-size: 14px;
  word-wrap: break-word;
  margin-top: 6px;
}

.mess_recomm_li_cetnter.mess_recomm_img img {
  width: 100%;
}

.introduce_right {
  width: 64%;
}

.sliding_div {
  width: 9px;
  height: 50px;
  border-radius: 4px;
  margin: 0 10px;
  background: #de9797;
  cursor: pointer;
}

.left_button img {
  transform: rotate(180deg);
}

.introduce_right .introduce_ul {
  /* width: 0; */
  align-items: center;
  transition: all 0.5s ease;
}

.introduce_right .gift_div {
  /* max-width: calc(100% - 180px); */
  width: 250px;
  /* width: 0; */
  margin: 0 !important;
  transition: all 0.5s ease;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.introduce_right .gift_div .gift_list {
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.introduce_right .gift_list::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.introduce_right .gift_list>i {
  width: 50px !important;
  /* margin: 0 5px; */
  cursor: pointer;
  display: inline-flex;
}

.introduce_right>.button_icon {
  margin: 0 15px;
  cursor: pointer;
  width: 48px;
}

.introduce_right>.button_icon:last-child {
  margin-right: 0;
  margin-left: 10px;
}

.demoCanvas {
  width: 100%;
  height: 400px;
  position: absolute;
  bottom: 90px;
  right: 20px;
  /* border:.005rem solid #000; */
  pointer-events: none;

  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}

.demoCanvasT {
  height: 300px;
  width: 100%;
}

.demoCanvasA {
  height: 300px;
}

.demoCanvasB {
  height: 300px;
  width: 200px;
  left: -100px;
  right: auto;
}

.demoCanvasC {
  height: 300px;
  left: 50%;
  transform: translateX(-50%);
  right: auto;
}

.demoCanvasD {
  height: 300px;
  width: 300px;
  bottom: 100px;
  /* border:.005rem solid #000;  */
}

.prize_tips {
  height: 30px;
  background: #e7c640;
  text-align: center;
  color: #333;
}

.prize_tips .prize_name {
  color: #2d82db;
  margin: 0 3px;
}

.prize_tips .prize_type {
  color: #f24d5b;
}

.gift_li.user_enter_li.flex_center {
  text-align: center;
  color: #fff;
  width: calc(100% - 20px);
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 14px;
  animation: myfirstT 4.5s ease;
}

@keyframes myfirstT {
  0% {
    bottom: 0px;
    opacity: 0;
  }

  20% {
    bottom: 40px;
    opacity: 0.8;
  }

  100% {
    bottom: 160px;
    opacity: 0;
  }
}

.gift_li.user_enter_li.flex_center>.user_enter_portrait {
  background-color: #fff;
}

.gift_li.user_enter_li.flex_center>span {
  display: inline-block;
  width: calc(100% - 50px);
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.discuss_center_text {
  border-top: 1px solid #ccc;
  padding-top: 10px;
  margin-top: 10px;
}

/* 幸运观众 */
.lucky_swiper {
  position: absolute;
  top: 49px;
  width: 100%;
  left: 0;
  right: 0;
  height: 40px;
  background: rgba(0, 0, 0, 0.1);
}

.lucky_swiper .swiper-slide {
  height: 100% !important;
}

.lucky_swiper .swiper-slide>i {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 4px;
}

.lucky_swiper .swiper-slide>span {
  color: #ff0000;
}

.label_li {
  font-size: 14px;
  color: #999;
  margin-left: 30px;
  line-height: 1em;
  cursor: pointer;
  position: relative;
}

.label_li>i {
  width: 15px;
  margin-right: 5px;
}

.label_li .share_div {
  position: absolute;
  bottom: 0;
  display: none;
  left: 50%;
  width: 150px;
  transform: translate(-50%, 110%);
  background: #fff;
  padding: 14px 14px 10px 14px;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  z-index: 999;
}

.label_li .share_div::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-top: 10px transparent dashed;
  border-left: 10px transparent dashed;
  border-bottom: 10px transparent dashed;
  border-right: 10px #fff solid;
  transform: translate(-50%, -100%) rotate(90deg);
}

.label_li.share_button:hover .share_div {
  display: block;
}

.wx_saosao {
  margin-top: 6px;
  font-size: 14px;
  color: #858fa6;
}

#qrcode {
  margin: auto;
}

.discuss_li .discuss_li_center {
  -webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
</style>


// WEBPACK FOOTER //
// src/components/pcVideo/pc_move.vue